import { useQuery, UseQueryResult } from 'react-query';
import { ITournament } from '../types/ITournament';
import { getTournament } from '../api/tournament';

export function useGetTournament(id: number): UseQueryResult<ITournament> {
    return useQuery(['tournament', id], () => getTournament(id), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 100,
        enabled: !!id,
    });
}
